import styled from '@emotion/styled';
import colors from '../../../theme/colors';
import borders from '../../../theme/borders';
import typography from '../../../theme/typography';
import { getBrowserDetails, isDarkMode } from '../../../utils/helpers';
import breakpoints from '../../../theme/material/breakpoints';

export const StyledCounterH2 = styled.h2(({ isValidCount }: { isValidCount: boolean }) => {
  const theme = isDarkMode() ? 'dark' : 'light';

  return {
    color: isValidCount ? colors.red[500] : !isDarkMode() ? colors[theme].blue.primary : colors[theme].blue.secondary,
    fontWeight: 700,
    fontSize: 14,
    lineHeight: typography.lineHeight,
  };
});

export const StyledVerticalLine = styled('span')(() => {
  const theme = isDarkMode() ? 'dark' : 'light';

  return {
    display: 'inline-block',
    borderLeft: `1px solid ${borders[theme].primary}`,
    margin: '0 8px',
    height: 36,
  };
});

export const StyledCountDetailsContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto',
  paddingTop: 30,
  paddingBottom: 30,

  [breakpoints.down(479.05)]: {
    paddingTop: 18,
    paddingBottom: 18,
  },
});

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
export const StyledMediasContainer = styled('div')(() => ({
  backgroundColor: !isDarkMode() ? colors.gray[200] : colors.blue[800],
  padding: '12px',
  borderRadius: '8px',
  minHeight: '320px',

  [breakpoints.down(479.05)]: {
    position: 'relative',
    paddingLeft: '15px',
    paddingRight: '10px',
  },
}));

export const scrollbarColor = !isDarkMode()
  ? `${colors.light.blue.primary} ${colors.light.gray.active}`
  : `${colors.dark.blue.secondary} ${colors.blue[900]}`;

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
export const StyledMediasInnerContainer = styled('div')(() => ({
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'flex-start',
  alignContent: 'flex-start',
  alignSelf: 'stretch',
  flexWrap: 'wrap',
  overflowY: 'auto',
  msOverflowStyle: 'auto',
  scrollbarWidth: 'thin',
  scrollbarColor: scrollbarColor,
  maxHeight: '420px',

  [breakpoints.down(479.05)]: {
    height: `${getBrowserDetails().hImgCalibration}px`,
    maxHeight: `${getBrowserDetails().hImgCalibration}px`,
  },

  '&::-webkit-scrollbar-track': {
    background: !isDarkMode() ? colors.light.gray.active : colors.blue[900],
  },

  '&::-webkit-scrollbar-thumb': {
    backgroundColor: !isDarkMode() ? colors.light.gray.active : colors.blue[900],
    borderRadius: '5px',
    border: `3px solid ${!isDarkMode() ? colors.light.blue.primary : colors.dark.blue.secondary}`,
  },

  '&::-webkit-scrollbar': {
    backgroundColor: !isDarkMode() ? colors.light.gray.active : colors.blue[900],
    width: '5px',
    borderRadius: '5px',
  },
}));

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
export const StyledMediaItemContainer = styled('div')(() => ({
  width: 140,
  height: 194,
  position: 'relative',
  padding: '7.5px',
  [breakpoints.down(355.05)]: {
    width: 130,
    height: 180,
    padding: 5,
  },
}));
